import React from 'react';
import { RouteProps, Route } from 'react-router-dom';

const PublicRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
  return <Route component={component} {...rest} />;
};

export default PublicRoute;
